// extracted by mini-css-extract-plugin
export default {"link":"ReasonCodeModalStyle_link__sdgCY"};